// Shared money formatting helpers for Crown Coupon.
// USDT is pegged 1:1 to USD, so we render amounts in a simple, easy-to-read
// format with thousands separators and a fixed decimal precision.
// We DO NOT change the underlying business numbers — only the display.

export function formatUsdt(value, { decimals = 2, withSymbol = true } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return withSymbol ? "— USDT" : "—";
  const num = n.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return withSymbol ? `${num} USDT` : num;
}

// React component: renders "1,000.00 USDT" with the gold "USDT" suffix
// already used across the app (text-[#D4AF37]). No custom logo — just the
// project's own gold-accented USDT text label. Fully accessible.
export function UsdtAmount({ value, decimals = 2, className = "", "data-testid": testid }) {
  const n = Number(value);
  const isValid = Number.isFinite(n);
  const num = isValid
    ? n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    : "—";
  return (
    <span className={`tabular whitespace-nowrap ${className}`} data-testid={testid} aria-label={`${num} USDT`}>
      {num} <span className="text-[#D4AF37]">USDT</span>
    </span>
  );
}
